<div class="c-form-field c-form-field--d c-form-field--img-uploader">
  <div class="c-form-field__body">
    <div class="c-form-field__placeholder" *ngIf="!value">
      <div class="mb-13">
        <svg width="33" height="30" viewBox="0 0 33 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.5 0.0666351H12.1854L12.4198 0.413323L14.8133 3.93957H32.5V29.9333H0.5V0.0666351ZM2.07377 1.71622V28.2837H30.9262V9.46208H16.7623V9.39747C16.6146 9.34281 16.481 9.24173 16.3836 9.09839L14.0015 5.58915H13.995L11.3721 1.71622H2.07377ZM15.9336 5.58915L17.4426 7.8125H30.9262V5.58915H15.9336ZM15.7131 12.2387H17.2869V21.5759L20.3258 18.3708L21.4351 19.5407L16.5 24.7457L11.5649 19.5407L12.6742 18.3708L15.7131 21.5759V12.2387Z"
            fill="#0F5EF7"
          />
        </svg>
      </div>
      <div class="d-flex"><span>Upload your file with Drag&Drop or</span>&nbsp;<span class="text-color--primary">Attach file</span></div>
      <span class="text-color text-color--gray">{{ additional }}. Size limit is {{ fileSizeLimit }} Mb</span>
      <input type="file" class="c-form-field__file-input" [accept]="accept" />
    </div>
    <div class="c-form-field__uploaded" *ngIf="value">
      <div class="c-form-field__data">
        <div class="c-form-field__data-row" *ngIf="fileData.format">
          <span class="text-color text-color--gray mr-8">Name:</span>
          <span>{{ fileData.name }}</span>
        </div>
        <div class="c-form-field__data-row" *ngIf="fileData.format">
          <span class="text-color text-color--gray mr-8">Format:</span>
          <span>{{ fileData.format | uppercase }}</span>
        </div>
        <div class="c-form-field__data-row" *ngIf="fileData.size">
          <span class="text-color text-color--gray mr-8">Size:</span>
          <span>{{ fileData.size }}</span>
        </div>
        <button type="button" p500-ui-confluent-button color="warn" class="mt-6" (click)="removeFile()">Delete File</button>
      </div>
    </div>
  </div>
</div>
